// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"7200dcda","453":"977c673a","606":"b424af52"}[chunkId] + ".chunk.js";
};